const subscriptionDOTD = function(){
	const accordions = new getAccordions4i();
	const helpers = new formHelpers4i();
	const forms = new forms4i();	
	let submitBtn, subscribeForm, recaptchaSiteKey, recaptchaActionName;
	
	const init = () => {
		getSubscribePanel();
	},
	getSubscribePanel = async () => {
		let panelHTML;
		try{
			const response = await fetch('/dealoftheday/deals/SubscriptionPanel', {
				method: 'GET', 
				headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch' }
			});
			panelHTML = await response.text();
		}catch(error){
			console.error(error);
		}
		
		if(panelHTML && document.getElementById("subscribePnl")){
			document.getElementById("subscribePnl").innerHTML = panelHTML;
			accordions.init(document.getElementById("subscribePnl"));
			setVariables();
			if (submitBtn) submitBtn.addEventListener("click", validate);
		}
	},
	setVariables = () => {
		subscribeForm = document.getElementById("subscribeForm");
		submitBtn = document.getElementById("btnSubmitSubscribe");
		recaptchaSiteKey = subscribeForm.querySelector("#RecaptchaSiteKeySubscribe").value;
		recaptchaActionName = subscribeForm.querySelector("#recaptchaActionNameSubscribe").value;
	},
	validate = (e) => {
		e.preventDefault();
		helpers.ClearStatus();
		helpers.ShowBusyBtn(submitBtn);
		submitBtn.setAttribute("disabled", "disabled");
		forms.formValidation(subscribeForm, subscribe, e, enableSubmitBtn);
	},
	enableSubmitBtn = () => {
		submitBtn.removeAttribute("disabled");
		helpers.ClearBusyBtn();
	},
	subscribe = async () => {
		grecaptcha.execute(recaptchaSiteKey, { action: recaptchaActionName }).then(function (token) {
			submitForm(token);
		});
    	},
	submitForm = async (token) =>{
	 	const data = {
			SubscribeEmail: document.getElementById('SubscribeEmail').value,
			RecaptchaActionName: recaptchaActionName,
			RecaptchaToken: token
		};
		let responseJSON;
		try{
			const response = await fetch('/dealoftheday/deals/Subscribe/', {
				method: 'POST', 
				body: JSON.stringify(data),
				headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch' }
			});
			responseJSON = await response.json();			
		}catch(error){
			enableSubmitBtn();
			console.error(error);
			helpers.ShowErrorStatus(submitBtn.parentNode, "There was an error processing your subscription request. Please try again.");
		}
		
		enableSubmitBtn();

		if(responseJSON){
			if (responseJSON.success) {
				document.getElementById('SubscribeEmail').value = "";
				helpers.ShowSuccessStatus(submitBtn.parentNode, responseJSON.message);
			}else{
				helpers.ShowErrorStatus(submitBtn.parentNode, responseJSON.message);
			}
		}
	};
	return{
		Init: init
	};
};

(function(){
	const subscription = new subscriptionDOTD();
	subscription.Init();
})();